import ItemPriceAndCTAs from '../common/ItemPriceAndCTAs'
import type { DetailItemCardVariant } from '../common/types'

import type {
  CruiseItem,
  SavedCruiseData,
} from 'tripPlanner/types/tripItem'
import { buildProductLink } from 'tripPlanner/utils/bookmark/restoreCart'
import CruiseV2SavedPriceDetails from 'tripPlanner/components/ItemOfferPrice/CruiseV2SavedPriceDetails'
import CruiseCtaContent from '../CTAContent/CruiseCtaContent'

interface Props {
  item: CruiseItem & { savedItemData: Extract<SavedCruiseData, { offerType: 'cruise' }> }
  variant: DetailItemCardVariant
}

function TourV2PriceAndCTAs({ item, variant }: Props) {
  const offerLink = buildProductLink(item) ?? ''
  const { price, currencyCode, cabinCategory, isOfferSoldOut } =
    item.savedItemData
  const isOfferAvailable = !isOfferSoldOut && !!price

  if (item.isSuggested) {
    // We don't currently do suggested cruises. If we ever do, update this.
    return null
  }

  const priceAreaContent = (
    <CruiseV2SavedPriceDetails
      price={price}
      currencyCode={currencyCode}
      cabinCategory={cabinCategory}
      isOfferAvailable={isOfferAvailable}
    />
  )

  const ctaAreaContent = (
    <CruiseCtaContent
      item={item}
      isOfferAvailable={isOfferAvailable}
      variant={variant}
      offerLink={offerLink}
    />
  )

  return (
    <ItemPriceAndCTAs>
      {priceAreaContent && <div className="price-area">{priceAreaContent}</div>}
      {ctaAreaContent && <div className="cta-area">{ctaAreaContent}</div>}
    </ItemPriceAndCTAs>
  )
}

export default TourV2PriceAndCTAs
